import { Route, Routes } from 'react-router-dom';
import Dashboard from '../views/Dashboard/Dashboard';
// import Home from '../views/Home/Home';
import Login from '../views/Login/Login';
import Customer from '../views/Customers/Customer/Customer';
import CustomerFreezeAccount from '../views/Customers/Customer/CustomerFreezeAccount';
import Customers from '../views/Customers/Customers';
import WithdrawalManager from '../views/WithdrawalManager/WithdrawalManager';
import USDRequest from '../views/USDRequest/USDRequest';
import USDRequestHeld from '../views/USDRequest/USDRequestHeld';
import USDRequestDetails from '../views/USDRequest/USDRequestDetails';
import ViewAllTargets from '../views/Customers/Customer/WalletsTab/Wallets/Target/viewall';
import ViewAllInvestments from '../views/Customers/Customer/WalletsTab/Wallets/Investify/viewall';
import ViewAllPiggybankTransactions from '../views/Customers/Customer/WalletsTab/Wallets/Piggybank/viewall';
import ViewAllFlexNairaTransactions from '../views/Customers/Customer/WalletsTab/Wallets/FlexNaira/viewall';
import ViewAllFlexDollarTransactions from '../views/Customers/Customer/WalletsTab/Wallets/FlexDollar/viewall';
import ViewAllSafelocks from '../views/Customers/Customer/WalletsTab/Wallets/Safelock/viewall';
import ViewAllGetIt from '../views/Customers/Customer/ProductsTab/GetItTab/viewall';
import SingleGetIt from '../views/Customers/Customer/ProductsTab/GetItTab/SingleGetIt';
import ViewAllIpo from '../views/Customers/Customer/ProductsTab/IpoTab/viewall';
import SingleIpoOffer from '../views/Customers/Customer/ProductsTab/IpoTab/SingleIpoOffer';
import SingleTarget from '../views/Customers/Customer/WalletsTab/Wallets/Target/SingleTarget';
import SingleSafelock from '../views/Customers/Customer/WalletsTab/Wallets/Safelock/SingleSafelock';
import SingleInvestment from '../views/Customers/Customer/WalletsTab/Wallets/Investify/SingleInvestment';
import SingleIpoInvestment from '../views/Customers/Customer/WalletsTab/Wallets/Investify/SingleIpoInvestment';

import useAuth from '../hooks/useAuth';
import { sessionStorageEnum } from '../api/enums';
import { useEffect } from 'react';
import Settings from '../views/Settings/Settings';
import RepushWebhook from '../views/RepushWebhook/RepushWebhook';
import InactivityLogoutTimer from '../helpers/utils/inactivity-timer';
import LargeWithdrawals from '../views/WithdrawalManager/LargeWithdrawals';
import SiteConfiguration from '../views/SiteConfiiguration/SiteConfiguration';
import PaymentProcessor from '../views/PaymentProcessor/PaymentProcessor';
import Home from '../views/Home/Home';

const AllRoutes = () => {
  const { logout } = useAuth();
  const accessToken = sessionStorage.getItem(sessionStorageEnum['session.storage.token']);
  InactivityLogoutTimer();

  useEffect(() => {
    if (accessToken === null || accessToken === '') {
      logout();
    }
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />}></Route>
      <Route path="/cs/freeze-account/:token" element={<CustomerFreezeAccount />}></Route>
      <Route element={<Dashboard />}>
        <Route path="/" element={<Home />} />
        <Route path="/default/view" element={<Home />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customer/:id" element={<Customer />} />
        <Route path="/view-all-targets/:id/:activeTab" element={<ViewAllTargets />} />
        <Route path="/view-all-investments/:id/:activeTab" element={<ViewAllInvestments />} />
        <Route path="/piggybank-transactions/:id" element={<ViewAllPiggybankTransactions />} />
        <Route path="/flexnaira-transactions/:id" element={<ViewAllFlexNairaTransactions />} />
        <Route path="/flexdollar-transactions/:id" element={<ViewAllFlexDollarTransactions />} />
        <Route path="/view-all-safelocks/:id/:activeTab" element={<ViewAllSafelocks />} />
        <Route path="/view-all-getit/:id/:activeTab" element={<ViewAllGetIt />} />
        <Route path="/view-getit/:id/:purchaseId/:activeTab" element={<SingleGetIt />} />
        <Route path="/view-all-ipo/:id/:activeTab" element={<ViewAllIpo />} />
        <Route path="/view-ipo-offer/:id/:offerId" element={<SingleIpoOffer />} />
        <Route path="/view-target/:id/:targetId" element={<SingleTarget />} />
        <Route path="/view-safelock/:id/:safelockId" element={<SingleSafelock />} />
        <Route path="/view-investment/:id/:investmentId/:activeTab" element={<SingleInvestment />} />
        <Route path="/view-ipo-investment/:id/:offerId" element={<SingleIpoInvestment />} />
        <Route path="/withdrawal-manager" element={<WithdrawalManager />} />
        <Route path="/large-withdrawals" element={<LargeWithdrawals />} />
        <Route path="/usd-request" element={<USDRequest />} />
        <Route path="/usd-withheld-request" element={<USDRequestHeld />} />
        <Route path="/usd-request/:id/:userId" element={<USDRequestDetails />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/repush-webhook" element={<RepushWebhook />} />
        <Route path="/site-configuration/:type" element={<SiteConfiguration />} />
        <Route path="/payment-processor" element={<PaymentProcessor />} />
      </Route>
    </Routes>
  );
};

export default AllRoutes;
